module.exports = __webpack_public_path__ + "img/state12_bg.06ea47d6.png";